export const SET_AUTH_LOADING = "SET_AUTH_LOADING";
export const SET_USER = "SET_USER";
export const SET_IS_AUTHENTICATED = "SET_IS_AUTHENTICATED";
export const SET_AUTH_STATE = "SET_AUTH_STATE";
export const SET_ROLE = "SET_ROLE";
